export const helperTourSteps = [
  {
    id: "sidebar-main",
    target: "[data-helper='sidebar']",
    titleKey: "steps.sidebarMain.title",
    descriptionKey: "steps.sidebarMain.description",
  },
  {
    id: "sidebar-tabs",
    target: "[data-helper='sidebar-main-tabs']",
    titleKey: "steps.sidebarTabs.title",
    descriptionKey: "steps.sidebarTabs.description",
  },
  {
    id: "header",
    target: "[data-helper='header']",
    titleKey: "steps.header.title",
    descriptionKey: "steps.header.description",
  },
];
